<section class="workspace-surface examples">
  @if (showHeadline()) {
    <h4 class="surface-title">{{ 'requirementIntake.examples.title' | translate }}</h4>
  }
  <p class="workspace-caption">
    {{ 'requirementIntake.examples.description' | translate }}
  </p>

  <div class="example-list">
    @for (example of examples(); track example.id) {
      <comp-example [example]="example"></comp-example>
    }
  </div>
</section>
